function formatTime(value) {
  if (!value) {
    return "";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }

  return parsed.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function NotificationsPanel({
  open,
  items = [],
  loading,
  error,
  onRefresh,
  onSelect,
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="notifications-panel" role="dialog" aria-label="Notifications">
      <div className="notifications-panel-header">
        <div>
          <div className="notifications-panel-title">Notifications</div>
          <div className="notifications-panel-meta">Live call and campaign events</div>
        </div>
        <button
          type="button"
          className="notifications-refresh-btn"
          onClick={onRefresh}
          disabled={loading}
        >
          {loading ? "..." : "Refresh"}
        </button>
      </div>

      {error ? (
        <div className="notifications-state notifications-state-error">{error}</div>
      ) : null}

      {!error && !items.length ? (
        <div className="notifications-state">
          {loading ? "Loading notifications..." : "No active notifications."}
        </div>
      ) : null}

      {!error && items.length ? (
        <div className="notifications-list">
          {items.map((item) => (
            <button
              type="button"
              className={`notification-item severity-${item.severity || "info"}`}
              key={item.id}
              onClick={() => onSelect(item)}
            >
              <span className="notification-dot" aria-hidden="true" />
              <span className="notification-copy">
                <span className="notification-title">{item.title}</span>
                <span className="notification-message">{item.message}</span>
                {item.created_at ? (
                  <span className="notification-time">{formatTime(item.created_at)}</span>
                ) : null}
              </span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
